import { UpdatesLayout } from './layout'
import { UpdatesRoutes } from './routes'

export const UpdatesNavigation = {
  Layout: UpdatesLayout,
  Routes: UpdatesRoutes,
}
